import React from "react";

export default function ReportTable({
  columns,
  data,
  emptyMessage,
  page = { page },
  limit = { limit },
   customTable 
}) {
  return (
    <div className="card p-3 shadow-sm">
      
      {data.length === 0 ? (
        <div className="text-center py-4 text-muted">
          {emptyMessage || "No records found."}
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered text-center mb-0">
            <thead className="table-dark">
              <tr>
                <th>S.No</th>
                {columns.map((c, idx) => (
                  <th key={idx} className="text-start">{c.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, rIdx) => (
                <tr key={rIdx}>
                  <td>{(page - 1) * limit + rIdx + 1}</td>
                  {columns.map((c, cIdx) => (
                    <td key={cIdx} className={c.className || "text-start"}>
                      {c.render ? c.render(row[c.key], row) : row[c.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
